import { SuppliersEntity } from '../../interfaces/Supplier/Supplier'
import { supplierActionsTypes } from '../types/supplierActionsTypes'

export type WarehouseAction = SupplierAction | SuppliersActionAsync

// Esto va a REDUX
export interface SupplierAction {
  type: typeof supplierActionsTypes.GET_SUPPLIERS_EXITO
  suppliers: SuppliersEntity[] | undefined
  error: string | undefined
}

export const getSuppliersAction = (
  suppliers?: SuppliersEntity[],
  error?: string
): SupplierAction => {
  return {
    type: supplierActionsTypes.GET_SUPPLIERS_EXITO,
    suppliers: suppliers,
    error
  }
}

// Esto va a SAGA
export interface SuppliersActionAsync {
  type: typeof supplierActionsTypes.GET_SUPPLIERS
}

export const getSuppliersActionAsync = (): SuppliersActionAsync => {
  return {
    type: supplierActionsTypes.GET_SUPPLIERS
  }
}
